import React from 'react'
import { MultiComboboxProps, MultiCombobox } from 'view/components/options'
import { Field } from 'view/components/inputs'
import { OrganisationType } from 'api'
import { getEnumValues, OrganisationTypeHelper } from 'model'

export type OrganisationTypeMultiComboboxProps = Omit<MultiComboboxProps<OrganisationType, string>, 'optionKeys'>

export const OrganisationTypeMultiCombobox = React.forwardRef(
  (props: OrganisationTypeMultiComboboxProps, ref: React.Ref<MultiCombobox>) => {
    const optionKeys = getEnumValues(OrganisationType)
    return (
      <MultiCombobox ref={ref} optionKeys={optionKeys} getOptionText={OrganisationTypeHelper.getName} horizontalLayout={true} {...props} />
    )
  }
)

export const OrganisationTypeMultiComboboxField = Field(OrganisationTypeMultiCombobox)
